// Constantes de texto en inglés para reemplazar el sistema de traducciones
export const TEXTS = {
  Index: {
    heroTitle: 'YOUR GLOBAL STREAMING GUIDE',
    heroSubtitle:
      "Uncover what's trending: Daily streaming charts for every country and service. Explore Netflix's TOP titles, Prime Video bestsellers, and global streaming highlights",
    movieCarouselTitle: "DISCOVER TODAY'S MOVIE",
    seriesCarouselTitle: "DISCOVER TODAY'S TV SHOWS",
    trendingCarouselTitle: 'TOP 10 ON STREAMING IN',
    discoverMoreButton: 'DISCOVER MORE',
    Movie: 'Movie',
    Series: 'TV Shows',
    pageTitle: 'Stream Discover - Discover the Best in Streaming',
    pageDescription:
      'Find the latest hits in movies, TV shows, and streaming services tailored to your region.',
    seeMore: 'DISCOVER MORE MOVIES AND TV SHOWS FROM',
    topSeriesAndMovies: 'TOP TV SHOWS & MOVIES',
    all: 'ALL',
    movies: 'MOVIES',
    series: 'TV SHOWS',
    loadingMore: 'Loading more'
  },
  Navbar: {
    hits: 'HITS',
    streamingServices: 'STREAMING SERVICES',
    contents: 'BROWSE TITLES',
    searchPlaceholder: 'Discover something to watch on streaming...',
    welcome: 'Welcome',
    login: 'Log In / Sign Up',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Log Out',
    country: 'Country',
    language: 'Language',
    platforms: 'Your Platforms',
    save: 'Save',
    comingSoon: 'FOR BUSINESS',
    pricing: 'PRICING',
    subscriptions: 'Subscriptions',
    reports: 'Reports'
  },
  Footer: {
    joinNewsletter: 'JOIN OUR NEWSLETTER',
    joinTelegram: 'JOIN OUR TELEGRAM',
    whatToWatch: 'WHAT TO WATCH',
    somethingToWatch: 'SOMETHING TO WATCH (COMING SOON)',
    swipeContent: 'SWIPE CONTENT (COMING SOON)',
    epg: 'PROGRAM GUIDE (COMING SOON)',
    whatToDiscover: 'WHAT TO DISCOVER',
    hits: 'NEW CONTENTS',
    streamingServices: 'STREAMING SERVICES',
    contents: 'CONTENTS',
    company: 'COMPANY',
    forBusiness: 'FOR BUSINESS',
    contactUs: 'CONTACT US',
    terms: 'TERMS & PRIVACY',
    subscribe: 'Subscribe',
    joinNewsletterLower: 'Join our newsletter',
    enterEmail: 'Enter your email',
    contactUsLower: 'Contact us',
    enterMessage: 'Enter your message',
    message: 'Message',
    send: 'Send',
    mySubscriptions: 'My Subscriptions'
  },
  Charts: {
    title: 'CHARTS',
    movies: 'MOVIES',
    tvShows: 'TV SHOWS',
    movie: 'Movie',
    series: 'Series',
    heroTitle: 'HITS',
    heroSubtitle: 'Weekly Top 10 lists of the most-watched shows and movies',
    creatorsDirectors: 'Creators / Directors:',
    viewMore: 'VIEW MORE',
    weeklyTop: 'Weekly Top',
    lastWeek: 'LAST UPDATE',
    hitsGlobal: 'In relation to Hits Global',
    Status: {
      UPCOMING: 'UPCOMING',
      'ON RELEASE': 'ON RELEASE'
    }
  },
  Contents: {
    heroTitle: 'CONTENTS',
    heroSubtitle: 'List of the Most Watched Movies and TV Shows in 2024 by genres',
    moviesUppercase: 'MOVIES',
    tvShowsUppercase: 'TV SHOWS',
    trendingNowWithDate: 'TRENDING {type} IN {month} {year}',
    best: 'BEST',
    in: 'IN'
  },
  Services: {
    pageTitle: 'Streaming Services - Stream Discover',
    pageDescription:
      'What are the leading streaming platforms? Which service boasts the largest subscriber base? Which streaming platforms have a global presence?',
    heroTitle: 'STREAMING SERVICES',
    heroSubtitle:
      'What are the leading streaming platforms? Which service boasts the largest subscriber base? Which streaming platforms have a global presence?',
    popularStreamingServices: 'MOST POPULAR STREAMING APPS IN ',
    allStreamingServices: 'ALL STREAMING SERVICES GLOBALLY',
    modalTitle: 'Exciting Changes Ahead!',
    modalMessage:
      'We are working on something amazing for you. Our site is under construction, but we promise it will be worth the wait. Stay tuned for a whole new experience coming soon!',
    modalThankYou: 'Thank you for your patience and support.',
    selectRegions: 'Select Regions',
    selectBusinessModels: 'Select Business Models',
    selectCountryOrigin: 'Select Country Origin',
    search: 'Search...'
  },
  Genres: {
    'Food': 'Food',
    'Fantasy': 'Fantasy',
    'Thriller/Mystery': 'Thriller/Mystery',
    'Short': 'Short',
    'Drama, Romance': 'Drama, Romance',
    'Sci-Fi': 'Sci-Fi',
    'Mini-Series': 'Mini-Series',
    'Türk Filmi': 'Turkish Film',
    'Family/Children': 'Family/Children',
    'Romance': 'Romance',
    'Drama': 'Drama',
    'Soap': 'Soap',
    'Comedy': 'Comedy',
    'Comedy, Drama': 'Comedy, Drama',
    'Children': 'Children',
    'Educational Content': 'Educational Content',
    'Science Fiction': 'Science Fiction',
    'Komedia': 'Comedy',
    'History': 'History',
    'Reality-TV': 'Reality TV',
    'War': 'War',
    'Adult, Drama': 'Adult, Drama',
    'Comedy, Horror': 'Comedy, Horror',
    'Adult': 'Adult',
    'Animation': 'Animation',
    'Sports': 'Sports',
    'Sci-Fi/Fantasy': 'Sci-Fi/Fantasy',
    'Martial Arts': 'Martial Arts',
    'Foreign/Independent': 'Foreign/Independent',
    'Reality': 'Reality',
    'Comedy, Romance': 'Comedy, Romance',
    'Documentary/Bio': 'Documentary/Bio',
    'Sport': 'Sport',
    'Horror': 'Horror',
    'Western': 'Western',
    'Game Show': 'Game Show',
    'Anime': 'Anime',
    'Action': 'Action',
    'Fantasy, Horror': 'Fantasy, Horror',
    'Dram': 'Drama',
    'Azione/Avventura': 'Action/Adventure',
    'Family': 'Family',
    'Crime, Drama': 'Crime, Drama',
    'Mystery, Thriller': 'Mystery, Thriller',
    'Music, Musical': 'Music, Musical',
    'Gerilim': 'Thriller',
    'Home and Garden': 'Home and Garden',
    'Crime': 'Crime',
    'Talk-Show': 'Talk-Show',
    'Komedi': 'Comedy',
    'Mystery': 'Mystery',
    'Documentary': 'Documentary',
    'Action, Adventure': 'Action, Adventure',
    'Eveil des consciences': 'Awakening of Consciousness',
    'Adventure': 'Adventure',
    'DK/Dokumentarfilm': 'DK/Documentary',
    'Talk Show': 'Talk Show',
    'Thriller': 'Thriller',
    'Game-Show': 'Game-Show',
    'LGBTQ': 'LGBTQ',
    'Biography': 'Biography',
    'News, Talk Show': 'News, Talk Show',
    'Reality TV': 'Reality TV',
    'Other': 'Other',
    'Indie': 'Indie',
    'Suspense': 'Suspense',
    'Musical': 'Musical',
    'News': 'News',
    'Komedie': 'Comedy',
    'Music': 'Music',
    'Martial Arts, Sport': 'Martial Arts, Sport',
    'Action/Adventure': 'Action/Adventure',
    'Travel': 'Travel',
    'Nature': 'Nature',
    'Children, Family': 'Children, Family',
    '\u202aAction/Adventure\u202c': 'Action/Adventure',
    'N/A': 'N/A'
  },
  Cookies: {
    title: 'We use cookies',
    description:
      'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    settings: 'Settings',
    functional: 'Functional',
    functionalDescription:
      'These cookies enable the website to provide enhanced functionality and personalization.',
    analytics: 'Analytics',
    analyticsDescription:
      'These cookies help us understand how visitors interact with our website.',
    marketing: 'Marketing',
    marketingDescription:
      'These cookies are used to track visitors across websites to display relevant advertisements.',
    save: 'Save Settings'
  },
  SimilarCarousel: {
    moreLikeThis: 'More Like This'
  },
  Platforms: {
    heroTitle: 'STREAMING SERVICES',
    heroSubtitle: 'Explore hundreds of streaming services worldwide',
    popularStreamingServices: 'POPULAR STREAMING SERVICES',
    allStreamingServices: 'ALL STREAMING SERVICES GLOBALLY',
    overviewTitle: 'DISCOVER MORE ABOUT ',
    category: 'Category',
    miscellaneous: 'Miscellaneous',
    businessModels: 'Business Models',
    defaultBusinessModel: 'Subscription, Subscription with Ads',
    launchYear: 'Launch Year',
    defaultLaunchYear: '2007',
    description: 'Description',
    contentAggregator: 'Content Aggregator',
    originals: 'Originals',
    liveChannelsOrEvents: 'Live Channels / Events',
    ads: 'Ads',
    yes: 'YES',
    no: 'NO',
    partnershipsTitle: 'MAJOR PARTNERSHIPS OF ',
    country: 'COUNTRY',
    partner: 'PARTNER',
    getFullList: 'DISCOVER THE FULL LIST OF MAJOR PARTNERSHIPS OF ',
    visitorsShareTitle: 'COUNTRIES WITH THE MOST VISITORS IN ',
    trafficShareDescription:
      'The full version updates traffic share variables monthly. Last free version update: 10/14/2024.',
    share: 'SHARE',
    businessModel: 'BUSINESS MODEL',
    getFullTrafficShareList:
      'DISCOVER THE FULL LIST OF COUNTRIES WITH THE MOST VISITS AND TRAFFIC IN ',
    contactsTitle: 'CONTACTS AND CONTENT BUYERS OF ',
    contactsDescription:
      'The full version updates contacts monthly. Last free version update: 10/14/2024.',
    company: 'COMPANY',
    position: 'POSITION',
    name: 'NAME',
    linkedin: 'LINKEDIN',
    linkedinText: 'LinkedIn',
    getFullContactsList: 'DISCOVER THE FULL LIST OF CONTACTS AND CONTENT BUYERS OF ',
    plansTitle: 'ALL PLANS OF ',
    planName: 'PLAN NAME',
    type: 'TYPE',
    duration: 'DURATION',
    price: 'PRICE',
    getFullPlansList:
      'DISCOVER THE FULL LIST OF AVAILABLE PLANS IN ALL COUNTRIES OF '
  },
  NewContent: {
    heroTitle: 'NEW CONTENT',
    heroSubtitle: 'Discover content added in the last week'
  },
  ComingSoon: {
    heroTitle: 'COMING SOON',
    heroSubtitle: "Discover what's coming soon on streaming services worldwide",
    comingSoon: 'COMING SOON',
    poster: 'Poster',
    title: 'Title',
    type: 'Type',
    availabilityDay: 'Availability Day',
    getFullComingSoonList: 'DISCOVER THE FULL COMING SOON LIST OF '
  },
  MoreDetails: {
    moreDetails: 'More Details',
    'Spoken Languages': 'Spoken Languages',
    'Type of Content': 'Type of Content',
    'Scripted': 'Scripted',
    'Content Age': 'Content Age',
    'Release Date': 'Release Date',
    'Hispanic': 'Hispanic',
    'Status': 'Status',
    'Alternative Titles': 'Alternative Titles',
    'Local Production': 'Local Production',
    'Genres': 'Genres',
    'Keywords': 'Keywords',
    'Homepage': 'Homepage',
    'Production Companies': 'Production Companies',
    'true': 'True',
    'false': 'False',
    notAvailable: 'No data available',
    notRated: 'Not Rated'
  },
  CharacterCarousel: {
    cast: 'Cast'
  },
  CrewCarousel: {
    crew: 'Crew'
  },
  SeasonsCard: {
    seasons: 'Seasons',
    episodes: 'Episodes',
    premiereDate: 'Premiere Date',
    airDate: 'Air Date'
  },
  SourcesTabs: {
    externalSources: 'External Sources',
    distributors: 'Distributors',
    marketplaces: 'Marketplaces',
    illegalSitesDetected: 'Illegal Sites Detected',
    notAvailable: 'Not Available'
  },
  Series: {
    unknown: 'Unknown',
    noSynopsis: 'Synopsis not available.',
    notRated: 'Not Rated',
    metaDescription: 'Details and streaming availability for {title}.',
    backdropAlt: 'Backdrop image',
    posterAlt: 'Movie poster',
    logoAlt: 'Movie logo',
    minutes: 'minutes',
    directors: 'DIRECTORS',
    'Creators': 'Creators',
    'Company': 'Company',
    'Network': 'Network',
    titleTab: 'Where to watch ',
    'Global Position': 'Global Position',
    'Hits Score': 'Hits Score',
    ivaScore: 'IVA Score'
  },
  Movie: {
    unknown: 'Unknown',
    noSynopsis: 'Synopsis not available.',
    notRated: 'Not Rated',
    metaDescription: 'Details and streaming availability for {title}.',
    backdropAlt: 'Backdrop image',
    posterAlt: 'Movie poster',
    logoAlt: 'Movie logo',
    minutes: 'minutes',
    'Directors': 'Directors',
    'Company': 'Company',
    'Network': 'Network',
    titleTab: 'Where to watch ',
    'Global Position': 'Global Position',
    'Hits Score': 'Hits Score',
    ivaScore: 'IVA Score'
  },
  StreamingAvailability: {
    platformSection: 'Platforms',
    availableOn: 'Available on',
    notAvailable: 'Not available',
    subscription: 'Subscription',
    transaction: 'Transaction',
    free: 'Free',
    yourServices: 'Your Services'
  },
  GlobalAvailability: {
    globalAvailability: 'Global Availability',
    available: 'Available',
    notAvailable: 'Not Available'
  }
}

// Función helper para obtener texto con fallback y soporte para interpolación
export const getText = (section, key, variables = {}) => {
  if (!TEXTS[section]) return key
  if (!TEXTS[section][key]) return key

  let text = TEXTS[section][key]

  // Interpolar variables si se proporcionan
  if (variables && typeof variables === 'object') {
    Object.keys(variables).forEach((varName) => {
      const regex = new RegExp(`{${varName}}`, 'g')
      text = text.replace(regex, variables[varName])
    })
  }

  return text
}

// Función helper para géneros con fallback
export const getGenreText = (genre) => {
  if (!genre) return ''
  return TEXTS.Genres[genre] || genre
}
